import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CustomerApi } from "../lib/api/CustomerApi";

const UsersListLayer = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await CustomerApi.index();
        if (response.error_code !== 200) {
          setErrorMsg("Gagal mengambil data sales.");
          setLoading(false);
          return;
        }

        setUsers(response.data);
        setLoading(false);
      } catch (error) {
        setErrorMsg("Gagal mengambil data sales.");
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  const formatCurrency = (value) => {
    if (value === null || value === undefined) {
      return "-";
    }
    const numberValue = parseFloat(value);
    if (isNaN(numberValue)) {
      return "-";
    }
    return numberValue.toLocaleString("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };

  if (loading) return <p>Loading...</p>;
  // if (errorMsg) return <p className="text-red-600">{errorMsg}</p>;

  return (
    // <div className="card h-100 p-0 radius-12">
    //   <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
    //     <div className="d-flex align-items-center flex-wrap gap-3">
    //       <span className="text-md fw-medium text-secondary-light mb-0">
    //         Show
    //       </span>
    //       <select
    //         className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
    //         defaultValue="Select Number"
    //       >
    //         <option value="Select Number" disabled>
    //           Select Number
    //         </option>
    //         <option value="1">1</option>
    //         <option value="2">2</option>
    //         <option value="3">3</option>
    //         <option value="4">4</option>
    //         <option value="5">5</option>
    //         <option value="6">6</option>
    //         <option value="7">7</option>
    //         <option value="8">8</option>
    //         <option value="9">9</option>
    //         <option value="10">10</option>
    //       </select>
    //       <form className="navbar-search">
    //         <input
    //           type="text"
    //           className="bg-base h-40-px w-auto"
    //           name="search"
    //           placeholder="Search"
    //         />
    //         <Icon icon="ion:search-outline" className="icon" />
    //       </form>
    //       <select
    //         className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
    //         defaultValue="Select Status"
    //       >
    //         <option value="Select Status" disabled>
    //           Select Status
    //         </option>
    //         <option value="Active">Active</option>
    //         <option value="Inactive">Inactive</option>
    //       </select>
    //     </div>
    //     <Link
    //       to="/add-user"
    //       className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
    //     >
    //       <Icon
    //         icon="ic:baseline-plus"
    //         className="icon text-xl line-height-1"
    //       />
    //       Add New User
    //     </Link>
    //   </div>
    //   <div className="card-body p-24">
    <div className="table-responsive scroll-sm">
      <table className="table bordered-table sm-table mb-0">
        <thead>
          <tr>
            <th scope="col">
              <div className="d-flex align-items-center gap-10">
                <div className="form-check style-check d-flex align-items-center">
                  <input
                    className="form-check-input radius-4 border input-form-dark"
                    type="checkbox"
                    name="checkbox"
                    id="selectAll"
                  />
                </div>
                S.L
              </div>
            </th>
            {/* <th scope="col">Join Date</th> */}
            <th scope="col">Name</th>
            <th scope="col">Email</th>
            <th scope="col">Balance</th>
            <th scope="col" className="text-center">
              Status
            </th>
            <th scope="col" className="text-center">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => (
            <tr key={index}>
              <td>
                <div className="d-flex align-items-center gap-10">
                  <div className="form-check style-check d-flex align-items-center">
                    <input
                      className="form-check-input radius-4 border border-neutral-400"
                      type="checkbox"
                      name="checkbox"
                    />
                  </div>
                  {user.id}
                </div>
              </td>
              {/* <td>{user.join_date}</td> */}
              <td>
                <div className="d-flex align-items-center">
                  <img
                    src={user.profile_img}
                    alt={user.name}
                    className="w-40-px h-40-px rounded-circle flex-shrink-0 me-12 overflow-hidden"
                  />
                  <div className="flex-grow-1">
                    <span className="text-md mb-0 fw-normal text-secondary-light">
                      {user.name}
                    </span>
                  </div>
                </div>
              </td>
              <td>
                <span className="text-md mb-0 fw-normal text-secondary-light">
                  {user.id == 1 ? "-" : user.email}
                </span>
              </td>
              {/* <td>{user.department}</td> */}
              <td className="text-end">{formatCurrency(user.balance)}</td>
              <td className="text-center">
                <span
                  className={`bg-${
                    user.status === "active" ? "success" : "danger"
                  }-focus text-${
                    user.status === "active" ? "success" : "danger"
                  }-600 border border-${
                    user.status === "active" ? "success" : "danger"
                  }-main px-24 py-4 radius-4 fw-medium text-sm`}
                >
                  {user.id == 1 ? "-" : user.status}
                </span>
              </td>
              <td className="text-center">
                {user.id != 1 ? (
                  <div className="d-flex align-items-center gap-10 justify-content-center">
                    <Link
                      to={`/profile/${user.id}`}
                      className="bg-info-focus text-info-600 bg-hover-info-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                    >
                      <Icon icon="lucide:edit" className="menu-icon" />
                    </Link>

                    <Link
                      to={`/transaction-by-user/${user.id}`}
                      className="bg-warning-focus bg-hover-warning-200 text-warning-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                    >
                      <Icon
                        icon="fluent:money-off-24-regular"
                        className="icon text-xl"
                      />
                    </Link>

                    <Link
                      to={`/deposit-by-user/${user.id}`}
                      className="remove-item-btn bg-success-focus bg-hover-success-200 text-success-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                    >
                      <Icon icon="vaadin:money-deposit" className="menu-icon" />
                    </Link>
                  </div>
                ) : (
                  "-"
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    // <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
    //   <span>Showing 1 to 10 of 12 entries</span>
    //   <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
    //     <li className="page-item">
    //       <Link
    //         className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px  text-md"
    //         to="#"
    //       >
    //         <Icon icon="ep:d-arrow-left" className="" />
    //       </Link>
    //     </li>
    //     <li className="page-item">
    //       <Link
    //         className="page-link text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md bg-primary-600 text-white"
    //         to="#"
    //       >
    //         1
    //       </Link>
    //     </li>
    //     <li className="page-item">
    //       <Link
    //         className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px"
    //         to="#"
    //       >
    //         2
    //       </Link>
    //     </li>
    //     <li className="page-item">
    //       <Link
    //         className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
    //         to="#"
    //       >
    //         3
    //       </Link>
    //     </li>
    //     <li className="page-item">
    //       <Link
    //         className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
    //         to="#"
    //       >
    //         4
    //       </Link>
    //     </li>
    //     <li className="page-item">
    //       <Link
    //         className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
    //         to="#"
    //       >
    //         5
    //       </Link>
    //     </li>
    //     <li className="page-item">
    //       <Link
    //         className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px  text-md"
    //         to="#"
    //       >
    //         {" "}
    //         <Icon icon="ep:d-arrow-right" className="" />{" "}
    //       </Link>
    //     </li>
    //   </ul>
    // </div>
    //   </div>
    // </div>
  );
};

export default UsersListLayer;
